import { useEffect, useMemo, useState } from 'react';
import { Ancestor } from '#enums/ancestors.ts';
import { type SectionType } from '#enums/mediaTypes.ts';
import { DetailsQuery } from '../Details/index.ts';
import { SlideoutDrawer } from '../SlideoutDrawer/index.tsx';
import { type TileItem } from '../Tile/types.ts';

export type ListingPreviewProps = {
  id: string | number;
  setActivePreview: (item: Pick<TileItem, 'id' | 'type'> | undefined) => void;
  type: SectionType;
};

export const ListingPreview = ({ id, setActivePreview, type }: ListingPreviewProps) => {
  const [open, setOpen] = useState<boolean>(true);

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setActivePreview(undefined);
      }, 310);
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const memoDetailsQuery = useMemo(
    () => <DetailsQuery enableLoader id={id} setActivePreview={setActivePreview} type={type} />,
    [id, type], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <SlideoutDrawer ancestor={Ancestor.ListingPreview} open={open} setOpen={setOpen}>
      {memoDetailsQuery}
    </SlideoutDrawer>
  );
};
